import { updateObject } from './../../utils/utility';

const initialState = {
  updatedByCt: "",
  previousUpdatedBy: "",
  spiff_hw_value_per_asset: "",
  previous_spiff_hw_value_per_asset: "",
  spiffCountries: {},
  consolidatedReportList: []
};

const setSpiffValues = (state, action) => {
    const { updatedByCt, previousUpdatedBy, spiff_hw_value_per_asset, previous_spiff_hw_value_per_asset } = action.data;
    return updateObject(state, {
        updatedByCt: updatedByCt,
        previousUpdatedBy: previousUpdatedBy,
        spiff_hw_value_per_asset: spiff_hw_value_per_asset,
        previous_spiff_hw_value_per_asset: previous_spiff_hw_value_per_asset
    });
};

const setSpiffCountries = (state, action) => {
    return updateObject(state, {
        spiffCountries: action.data
    });
}

const setSpiffReports = (state, action) => {
    return updateObject(state, {
        consolidatedReportList: action.data.consolidatedReportList
    });
}

const reducer = (state = initialState, action) => {
    if(action.type === 'SET_SPIFF_VALUES') {
        return setSpiffValues(state, action);
    } else if(action.type === 'SET_SPIFF_COUNTRIES') {
        return setSpiffCountries(state, action);
    } else if(action.type === 'SET_SPIFF_REPORTS') {
        return setSpiffReports(state, action);
    }
    return state;
}

export default reducer;